import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';

import FiltersDialog from './FiltersDialog';

import {
  jobTypeFilters,
  employmentTypeFilters,
  locationTypeFilters
} from '../../services/jobFilters';
import CollapsibleChips from './CollapsibleChips';

import colors from '../../assets/colors';
import fontSize from '../../assets/fontSize';

import { getFilterCount } from '../../services/axios';

const StyledCard = styled(Card)`
  && {
    position: sticky;
    top: 0;
    z-index: 2;
  }
`;
const FilterSectionWrapper = styled.div`
  padding: ${({ isMobile }) => !isMobile && '0.5rem'};
  background-color: ${({ isMobile }) => !isMobile && colors.lightGrey};
  border-radius: 4px;
`;
const CardContent = styled.div`
  padding: ${({ isMobile }) => (isMobile ? '0' : '1rem')};
`;
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'row' : 'column')};
  justify-content: center;
  background-color: ${({ isMobile }) => isMobile && colors.greyLight};
  gap: 0.5rem;
  box-sizing: border-box;
  ${({ isMobile }) =>
    isMobile &&
    `
    padding: 0.5rem;
    justify-content: flex-start;
    overflow-x: auto;
    width: 100%;
  `}

  ::-webkit-scrollbar {
    display: none;
  }
`;
const FilterHeader = styled.div`
  display: ${({ isMobile }) => (isMobile ? 'none' : 'flex')};
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
`;
const FilterTitle = styled.p`
  margin: 0;
  font-size: ${fontSize.large};
  font-weight: 600;
`;
const StyledButton = styled(Button)`
  && {
    text-transform: none;
    color: ${colors.primary};
    white-space: nowrap;
    font-size: ${({ isMobile }) => isMobile && fontSize.regular};

    :disabled {
      color: ${colors.grey};
    }
  }
`;

const NO_FILTERS_APPLIED = 0;

const JobListFilter = props => {
  const { isMobile, activeFilters, handleApplyFilters, resetFilters } = props;
  const [filterCounts, setFilterCounts] = useState({
    helper_type: [],
    employment_type: [],
    state: []
  });

  useEffect(() => {
    const fetchFilterCount = async () => {
      const response = await getFilterCount();

      if (response?.isSuccess) {
        setFilterCounts(response?.filterCounts);
      }
    };

    fetchFilterCount();
  }, []);

  const hasFiltersApplied =
    activeFilters?.jobType?.length > NO_FILTERS_APPLIED ||
    activeFilters?.employmentType?.length > NO_FILTERS_APPLIED ||
    activeFilters?.location?.length > NO_FILTERS_APPLIED;

  return (
    <StyledCard elevation={isMobile ? 0 : 2}>
      <CardContent isMobile={isMobile}>
        <FilterHeader isMobile={isMobile}>
          <FilterTitle>Filters</FilterTitle>
          <StyledButton onClick={resetFilters} disabled={!hasFiltersApplied}>
            Reset All
          </StyledButton>
        </FilterHeader>
        <ButtonContainer isMobile={isMobile}>
          {isMobile && hasFiltersApplied && (
            <StyledButton onClick={resetFilters} size="small" isMobile>
              Reset All
            </StyledButton>
          )}
          <FilterSectionWrapper isMobile={isMobile}>
            <FiltersDialog
              filterTitle="Job Type"
              filterType="jobType"
              filterCounts={filterCounts?.helper_type}
              appliedFilters={activeFilters?.jobType}
              filters={jobTypeFilters}
              handleApplyFilters={handleApplyFilters}
              isActive={activeFilters?.jobType?.length > NO_FILTERS_APPLIED}
              isMobile={isMobile}
            />
            {!isMobile && (
              <CollapsibleChips
                type="jobType"
                open={activeFilters?.jobType?.length > NO_FILTERS_APPLIED}
                handleApplyFilters={handleApplyFilters}
                filterCounts={filterCounts?.helper_type}
                appliedFilters={activeFilters?.jobType}
              />
            )}
          </FilterSectionWrapper>
          <FilterSectionWrapper isMobile={isMobile}>
            <FiltersDialog
              filterTitle="Employment Type"
              filterType="employmentType"
              filterCounts={filterCounts?.employment_type}
              appliedFilters={activeFilters?.employmentType}
              filters={employmentTypeFilters}
              handleApplyFilters={handleApplyFilters}
              isActive={
                activeFilters?.employmentType?.length > NO_FILTERS_APPLIED
              }
              isMobile={isMobile}
            />
            {!isMobile && (
              <CollapsibleChips
                type="employmentType"
                open={
                  activeFilters?.employmentType?.length > NO_FILTERS_APPLIED
                }
                handleApplyFilters={handleApplyFilters}
                filterCounts={filterCounts?.employment_type}
                appliedFilters={activeFilters?.employmentType}
              />
            )}
          </FilterSectionWrapper>
          <FilterSectionWrapper isMobile={isMobile}>
            <FiltersDialog
              filterTitle="Location"
              filterType="location"
              filterCounts={filterCounts?.state}
              appliedFilters={activeFilters?.location}
              filters={locationTypeFilters}
              handleApplyFilters={handleApplyFilters}
              isActive={activeFilters?.location?.length > NO_FILTERS_APPLIED}
              isMobile={isMobile}
            />
            {!isMobile && (
              <CollapsibleChips
                type="location"
                open={activeFilters?.location?.length > NO_FILTERS_APPLIED}
                handleApplyFilters={handleApplyFilters}
                filterCounts={filterCounts?.state}
                appliedFilters={activeFilters?.location}
              />
            )}
          </FilterSectionWrapper>
        </ButtonContainer>
      </CardContent>
    </StyledCard>
  );
};

export default JobListFilter;
